function IconTalkTimeLowBubbles() {
  return (
    <svg width="93" height="34" viewBox="0 0 93 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.5">
        <path
          d="M59.5312 14.875C59.5312 7.4375 66.7563 1.59375 76 1.59375C85.2437 1.59375 92.4688 7.4375 92.4688 14.875C92.4688 22.3656 85.0844 28.4219 76 28.4219C74.5125 28.4219 73.025 28.2625 71.5906 27.8906L63.4625 31.2375C63.4094 31.3437 63.3031 31.3438 63.25 31.3438C63.1437 31.3438 63.0375 31.2906 62.9313 31.2375C62.7719 31.1312 62.7188 30.9719 62.7188 30.7594L63.25 23.4281C60.8594 21.0375 59.5312 18.0094 59.5312 14.875Z"
          fill="white"
        />
      </g>
    </svg>
  );
}

export { IconTalkTimeLowBubbles };
